import { AllForecastComponents, ForecastComponents, ForecastTime, } from "../../app/forecastSurface";
import { SurfaceEnum } from "../../components/UserVisibleStrings";
import { RouteMetadata } from "../../generated/gpb/api/route";

export function formatForecastTime(
    date: string | undefined,
    hour: string | undefined,
    localTime = false
): string
{

    if ( date !== undefined )
    {
        date =
      date.substring( 0, 4 ) +
      "-" +
      date.substring( 4, 6 ) +
      "-" +
      date.substring( 6, 8 );
    }
    const utcDate = new Date( `${date}T${hour}:00:00Z` );

    if ( localTime )
    {
        const localDate = new Date( utcDate.toLocaleString() );
        const formattedDate = localDate.toLocaleString( "en-US", {
            month: "2-digit",
            day: "2-digit",
            year: "numeric",
            hour: "numeric",
            hour12: true,
        } );
        const timeZone = localDate.toLocaleTimeString( "en-US", { timeZoneName: "short" } ).split( " " )[2];
        return `${formattedDate} ${timeZone}`;
    }

    return date !== undefined && hour !== undefined ? date + " " + hour + ":00 UTC" : "Forecast Time Missing";
}



export function moreRecent(
    forecastTime: ForecastTime,
    data: ForecastTime | undefined
)
{
    if ( !data ) return false;

    return (
        data.date > forecastTime.date ||
    ( data.date === forecastTime.date && data.hour > forecastTime.hour )
    );
}

// get subset of the forecast taus for which surface data was generated
export function getGeoJSONTaus(
    allComponents: AllForecastComponents | undefined,
    surfaceName: SurfaceEnum
) : Array<number>
{
    if ( allComponents === undefined ) return [];
    const comps = allComponents.impact;
    return comps?.components.find( ( ct ) => ct.name === surfaceName )?.geojsonTaus ?? [];
}

// Get taus based on the surfaceEnum and components
export function getComponentForecastTaus(
    surfaceEnum: SurfaceEnum,
    components: ForecastComponents | undefined
)
{
    return components?.components.find( ( ct ) => ct.name === surfaceEnum )?.taus ?? [];
}

// Get the min and max time based on component taus and route metadata
export function getMinMaxTimes(
    componentTaus: Array<number>,
    routeMetadata: RouteMetadata | undefined
)
{
    const minTime = ( () =>
    {
        let adjustedStart = componentTaus.length > 0 ? componentTaus[0] ?? 0 : 0;
        if ( routeMetadata?.startTime !== undefined )
        {
            const date = new Date( routeMetadata.startTime.getTime() );
            adjustedStart = date.valueOf();
        }
        return adjustedStart;
    } )();

    const maxTime = ( () =>
    {
        let adjustedEnd = componentTaus.length > 0 ? componentTaus[componentTaus.length - 1] ?? 0 : 0;
        if ( routeMetadata?.endTime !== undefined )
        {
            const date = new Date( routeMetadata.endTime.getTime() );
            adjustedEnd = date.valueOf();
        }
        return adjustedEnd;
    } )();

    return { minTime, maxTime };
}

// Main function to recalculate forecast taus
export function recalculateComponentForecastTaus(
    surfaceEnum: SurfaceEnum,
    components: ForecastComponents | undefined,
    routeMetadata: RouteMetadata | undefined
)
{
    const componentTaus = getComponentForecastTaus( surfaceEnum, components );
    const { minTime, maxTime } = getMinMaxTimes( componentTaus, routeMetadata );

    return { componentTaus, minTime, maxTime };
}
